// src/pages/Admin/Casting/components/MatEditor.jsx
import React from "react";
import Button from "./../../../components/Button/Button.jsx";
import { FaSave } from "react-icons/fa";

const EMPTY_SLOT = (idx) => ({
  slot_index: idx,
  label: "",
  note: "",
  is_active: true,
});

export default function MatEditor({
  loading,
  saving,
  selectedMat,
  form,
  setForm,
  onSave,
}) {
  const updateSlot = (idx, patch) => {
    setForm((s) => ({
      ...s,
      slots: (s.slots || []).map((x) =>
        x.slot_index === idx ? { ...x, ...patch } : x
      ),
    }));
  };

  return (
    <div className="rounded-3xl bg-white/80 dark:bg-slate-900/70 backdrop-blur ring-1 ring-black/5 dark:ring-white/10 shadow-xl p-4 sm:p-6">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h2 className="text-lg sm:text-xl font-extrabold text-slate-900 dark:text-white">
            Édition Tapis {selectedMat}
          </h2>
          <p className="text-sm text-slate-600 dark:text-slate-300">
            1 à 3 catégories maximum par tapis.
          </p>
        </div>

        <Button
          text={saving ? "Enregistrement…" : "Enregistrer"}
          icon={FaSave}
          onClick={onSave}
          className="btn-primary"
          disabled={saving}
        />
      </div>

      <div className="mt-5 grid gap-4 md:grid-cols-2">
        <div>
          <label className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-300">
            Libellé du tapis
          </label>
          <input
            value={form.label}
            onChange={(e) => setForm((s) => ({ ...s, label: e.target.value }))}
            className="mt-1 w-full rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-2 outline-none focus:ring-2 focus:ring-sky-400"
            placeholder={`TAPIS ${selectedMat}`}
          />
        </div>

        <div>
          <label className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-300">
            Ordre d'affichage
          </label>
          <input
            type="number"
            min={1}
            max={10}
            value={form.sort_order}
            onChange={(e) =>
              setForm((s) => ({ ...s, sort_order: e.target.value }))
            }
            className="mt-1 w-full rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-2 outline-none focus:ring-2 focus:ring-sky-400"
          />
        </div>

        <div className="md:col-span-2">
          <label className="inline-flex items-center gap-2 text-sm text-slate-700 dark:text-slate-200">
            <input
              type="checkbox"
              checked={Boolean(form.is_open)}
              onChange={(e) =>
                setForm((s) => ({ ...s, is_open: e.target.checked }))
              }
            />
            <span>Tapis ouvert (visible sur l’écran)</span>
          </label>
        </div>
      </div>

      <div className="mt-6 space-y-3">
        {[1, 2, 3].map((idx) => {
          const slot =
            (form.slots || []).find((s) => s.slot_index === idx) ||
            EMPTY_SLOT(idx);

          return (
            <div
              key={idx}
              className="rounded-2xl border border-slate-200/70 dark:border-slate-800 bg-white/70 dark:bg-slate-900/40 p-3"
            >
              <div className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-300 mb-2">
                Catégorie {idx}
              </div>

              <div className="grid md:grid-cols-2 gap-3">
                <input
                  value={slot.label}
                  onChange={(e) => updateSlot(idx, { label: e.target.value })}
                  className="w-full rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-2 outline-none focus:ring-2 focus:ring-sky-400"
                  placeholder="Ex : Benjamins -34kg"
                />

                <input
                  value={slot.note}
                  onChange={(e) => updateSlot(idx, { note: e.target.value })}
                  className="w-full rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-2 outline-none focus:ring-2 focus:ring-sky-400"
                  placeholder="Note (optionnel) : 'Pesée 8h30'..."
                />
              </div>

              <div className="mt-2 flex items-center justify-between">
                <label className="inline-flex items-center gap-2 text-sm text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    checked={Boolean(slot.is_active)}
                    onChange={(e) =>
                      updateSlot(idx, { is_active: e.target.checked })
                    }
                  />
                  Afficher
                </label>

                <button
                  type="button"
                  onClick={() =>
                    updateSlot(idx, { label: "", note: "", is_active: true })
                  }
                  className="text-sm font-semibold text-rose-700 hover:underline dark:text-rose-300"
                >
                  Vider
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {loading && (
        <div className="mt-4 text-sm text-slate-600 dark:text-slate-300">
          Chargement…
        </div>
      )}
    </div>
  );
}
